'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _vuex = require('vuex');

var _vuex2 = _interopRequireDefault(_vuex);

var _qs = require('qs');

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

var state = {
  user: {},
  token: '',
  socketState: false,
  pid: 0 };

var mutations = {
  set_state: function set_state(state) {
    var localState = _qs2.default.parse(localStorage.getItem('state'), { strictNullHandling: true });
    for (var k in state) {
      state[k] = localState[k];
    }
  },
  set_user: function set_user(state, user) {
    state.user = user;
  },
  set_token: function set_token(state, token) {
    state.token = token;
  },
  set_socketState: function set_socketState(state, value) {
    state.socketState = value;
  },
  set_cart_count: function set_cart_count(state, cartCount) {
    state.user.cart_count = Number(state.user.cart_count) + cartCount;
  },
  set_pid: function set_pid(state, pid) {
    state.pid = pid;
  },
  set_agent_id: function set_agent_id(state, agent_id) {
    state.user.agent_id = agent_id;
  },
  set_shop_id: function set_shop_id(state, shop_id) {
    state.user.shop_id = shop_id;
  }
};

exports.default = new _vuex2.default.Store({
  state: state,
  mutations: mutations
});


// WEBPACK FOOTER //
// ./src/store.js